var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "user-join"
  }, [_c('h3', {
    staticClass: "add-text"
  }, [_vm._v(_vm._s(_vm.title))]), _c('Form', {
    ref: "formCustom",
    staticClass: "form",
    attrs: {
      "model": _vm.formObj,
      "label-width": 80,
      "rules": _vm.ruleCustom
    }
  }, [_c('FormItem', {
    attrs: {
      "label": $t("fvdo2", "姓氏"),
      "prop": "userSurname"
    }
  }, [_c('Input', {
    attrs: {
      "maxlength": "60",
      "type": "text"
    },
    model: {
      value: _vm.formObj.userSurname,
      callback: function ($$v) {
        _vm.$set(_vm.formObj, "userSurname", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formObj.userSurname"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": $t("esq22", "名字"),
      "prop": "userGivenName"
    }
  }, [_c('Input', {
    attrs: {
      "maxlength": "60",
      "type": "text"
    },
    model: {
      value: _vm.formObj.userGivenName,
      callback: function ($$v) {
        _vm.$set(_vm.formObj, "userGivenName", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formObj.userGivenName"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": $t("i1y32", "昵称"),
      "prop": "userNickname"
    }
  }, [_c('Input', {
    attrs: {
      "maxlength": "60",
      "type": "text"
    },
    model: {
      value: _vm.formObj.userNickname,
      callback: function ($$v) {
        _vm.$set(_vm.formObj, "userNickname", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formObj.userNickname"
    }
  })], 1), _c('FormItem', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "label": $t("gfjm2", "工号"),
      "prop": "userNumber"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.formObj.userNumber,
      callback: function ($$v) {
        _vm.$set(_vm.formObj, "userNumber", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formObj.userNumber"
    }
  })], 1), _vm.isEdit ? _c('FormItem', {
    attrs: {
      "label": $t("haa72", "手机")
    }
  }, [_c('ShowEncInput', {
    attrs: {
      "disabled": true,
      "encText": _vm.formObj.mobile,
      "params": {
        unitId: _vm.item.unitId,
        userId: _vm.item.userId
      },
      "mode": "UNIT_USER_MOBILE"
    }
  })], 1) : _c('FormItem', {
    attrs: {
      "label": $t("haa72", "手机"),
      "prop": "mobile"
    }
  }, [_c('countryCode', {
    ref: "countryCode",
    attrs: {
      "isRequired": false,
      "exist": _vm.isEdit
    },
    model: {
      value: _vm.formObj,
      callback: function ($$v) {
        _vm.formObj = $$v;
      },
      expression: "formObj"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": $t("pgxs2", "部门")
    }
  }, [_c('LineOrgTag', {
    staticClass: "form_item_left edit",
    attrs: {
      "list": _vm.scopeList
    },
    on: {
      "change": function ($event) {
        return _vm.openModal('addOrg');
      }
    }
  })], 1), _vm.isEdit ? _c('FormItem', {
    attrs: {
      "label": $t("padf2", "邮箱"),
      "prop": "enc_email"
    }
  }, [_c('ShowEncInput', {
    attrs: {
      "encText": _vm.formObj.userEmail,
      "params": {
        unitId: _vm.item.unitId,
        userId: _vm.item.userId
      },
      "mode": "UNIT_USER_EMAIL",
      "documentId": "userJoinEncInputEmail"
    },
    model: {
      value: _vm.formObj.enc_email,
      callback: function ($$v) {
        _vm.$set(_vm.formObj, "enc_email", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formObj.enc_email"
    }
  })], 1) : _c('FormItem', {
    attrs: {
      "label": $t("padf2", "邮箱"),
      "prop": "userEmail"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "element-id": "userJoinInputEmail"
    },
    on: {
      "input": () => _vm.onInputRange(this, _vm.formObj, 'userEmail', 'userJoinInputEmail')
    },
    model: {
      value: _vm.formObj.userEmail,
      callback: function ($$v) {
        _vm.$set(_vm.formObj, "userEmail", $$v);
      },
      expression: "formObj.userEmail"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": $t("op822", "身份"),
      "prop": "isAdmin"
    }
  }, [_c('Checkbox', {
    staticClass: "form_item_left",
    attrs: {
      "true-value": "T",
      "false-value": "F"
    },
    model: {
      value: _vm.formObj.isAdmin,
      callback: function ($$v) {
        _vm.$set(_vm.formObj, "isAdmin", $$v);
      },
      expression: "formObj.isAdmin"
    }
  }, [_vm._v($t("io38z3", "管理员"))])], 1)], 1), _c('div', {
    staticClass: "action"
  }, [!_vm.isEdit ? _c('Button', {
    attrs: {
      "loading": _vm.loading,
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.submit(true);
      }
    }
  }, [_vm._v($t("1dagti7", "保存并继续添加"))]) : _vm._e(), _c('Button', {
    staticClass: "buttom",
    attrs: {
      "loading": _vm.loading,
      "type": `${_vm.isEdit ? 'primary' : 'default'}`
    },
    on: {
      "click": function ($event) {
        return _vm.submit(false);
      }
    }
  }, [_vm._v($t("e32z2", "保存"))]), _c('Button', {
    staticClass: "buttom",
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v($t("ev022", "取消"))])], 1), _c('ChangeOrg', {
    ref: "ChangeOrg",
    attrs: {
      "scopeList": _vm.scopeList
    },
    on: {
      "change": _vm.onChangeOrg
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };